import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class SplitFunc {
    constructor() {
        this.init();
    }

    init() {
        this.splitLine();
        this.splitText();
    }

    // 共通分割処理
    _splitCommon(wrapperClass, targetClass, splitType, processCallback) {
        const wrappers = gsap.utils.toArray(wrapperClass);
        const processedTargets = new Set();

        // wrapper内を連番処理（クラスを跨いでアニメーション等の段階つけたい場合）
        wrappers.forEach((wrapper) => {
            const targets = wrapper.querySelectorAll(targetClass);
            let globalIndex = 0;

            targets.forEach((target) => {
                processedTargets.add(target);
                const split = new SplitText(target, { type: splitType });
                globalIndex = processCallback(split, globalIndex, true);
            });
        });

        // 個別処理
        const allTargets = gsap.utils.toArray(targetClass);
        allTargets.forEach((target) => {
            if (!processedTargets.has(target)) {
                const split = new SplitText(target, { type: splitType });
                processCallback(split, 0, false);
            }
        });
    }

    // テキストを文字単位で分割
    splitText() {
        this._splitCommon(".js-split-text-wrapper", ".js-split-text", "words,chars", (split, startIndex, isGlobal) => {
            split.chars.forEach((char, i) => {
                const index = isGlobal ? startIndex + i : i;

                char.classList.add("char", "char-" + (index + 1));
                char.style.setProperty("--char-index", index);
            });
            return isGlobal ? startIndex + split.chars.length : 0;
        });
    }

    // テキストを行単位で分割
    splitLine() {
        const processLine = (line, index) => {
            const inner = document.createElement("div");
            inner.className = "line-inner char";
            inner.innerHTML = line.innerHTML;
            line.innerHTML = "";
            line.appendChild(inner);
            line.classList.add("line", "line-" + (index + 1));
            line.style.setProperty("--line-index", index);
        };

        this._splitCommon(".js-split-line-wrapper", ".js-split-line", "lines,words,chars", (split, startIndex, isGlobal) => {
            split.lines.forEach((line, i) => {
                const index = isGlobal ? startIndex + i : i;
                processLine(line, index);
            });
            return isGlobal ? startIndex + split.lines.length : 0;
        });
    }
}
